import ResendPhoneTokenError from './ResendPhoneTokenError';
class PhoneNumberIsNotRegistered extends ResendPhoneTokenError {
    constructor(options) {
        super('Investor does not have a registered phone yet', options);
    }
}
export default PhoneNumberIsNotRegistered;
